module.exports = [{
      plugin: require('G:/code/icar/web/gatsby2019/node_modules/gatsby-remark-images/gatsby-browser.js'),
      options: {"plugins":[],"maxWidth":960},
    }]
